<template>
  <div>
    <div class="modal-mask" v-if="visivel">      
      <div class="modal-wrapper" name="modal">
        <div
          class="w3-modal-content w3-animate-zoom"
          @click.stop>

          <span @click="fechar()" class="w3-button w3-display-topright">&times;</span>
          <header class="w3-col s12">
            <h4 v-if="multiSelecao == 'S'" class="texto-vermelho titulo">Selecione os Locais</h4>
            <h4 v-if="multiSelecao == 'N'" class="texto-vermelho titulo">Selecione o Local</h4>
          </header>
          
          <div
            class="w3-col s12"
            style="max-height: calc(100vh - 320px); min-height: 200px; overflow: auto">

            <table class="w3-table w3-white">
              <tbody>
                <tr
                  :key="indice"
                  v-for="(local, indice) in locais"
                  class="w3-margin-top"
                  style="border: 20px; border-color: #fff;"
                  v-bind:class="getClasseLocalSelecionado(local.selecionado)"
                  @click="selecionarLocal(local.local_id)">

                  <td style="font-size: 14px!important;">
                    <i v-if="(multiSelecao == 'S') && (local.selecionado)" class="far fa-check-square"></i>
                    <i v-if="(multiSelecao == 'S') && (!local.selecionado)" class="far fa-square"></i>

                    <i v-if="(multiSelecao == 'N') && (local.selecionado)" class="far fa-dot-circle"></i>
                    <i v-if="(multiSelecao == 'N') && (!local.selecionado)" class="far fa-circle"></i>
                    <span >  {{local.local_id}} - {{local.nome}}</span>
                  </td>
                  <td>{{local.tipo}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="w3-container">
            <div class="w3-center">
              <button
                class="w3-button w3-theme"
                @click="confirmar()"
                style="margin: auto; margin-top: 10px; margin-bottom: 10px;">
                <i class="fas fa-check"></i>
                <span>Confirmar</span>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import toastr from 'toastr'
  import RLocalProduto from '@/components/Rest/RLocalProduto'

  export default {
    name: 'ModalLocaisProdutos',
    props: ['multiSelecao', 'locaisSelecionadosIds'],

    components: toastr,

    data() {    
      return {
        locais: [],
        visivel: false
      }
    },

    methods: {
      async abrir() {
        await this.buscarLocais();
        this.visivel = true;
      },

      fechar() {
        this.visivel = false;
      },

      confirmar() {
        let retorno = [];

        for (let i = 0; i < this.locais.length; i++) {
          if (this.locais[i].selecionado) {
            retorno.push(this.locais[i].local_id);
          }
        }

        if (retorno.length == 0) {
          toastr.error('Selecione pelo menos um local!');
          return;
        }

        if ((!this.multiSelecao == 'S') && (retorno.length != 1)) {
          toastr.error('Selecione apenas um local!');
          return;
        }

        this.$emit('confirmar', retorno);
        this.visivel = false;
      },

      async buscarLocais() {
        try {
          let retorno = await RLocalProduto.buscarTodosLocaisProdutos(this.axios);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.locais = JSON.parse(JSON.stringify(retorno.dados));

          for (let i = 0; i < this.locais.length; i++) {
            this.locais[i].selecionado = false;

            if ((this.locaisSelecionadosIds) && (this.locaisSelecionadosIds.length > 0)) {
              for (let j = 0; j < this.locaisSelecionadosIds.length; j++) {

                let local_selecionar_id = this.locaisSelecionadosIds[0];
                if (this.multiSelecao == 'S') {
                  local_selecionar_id = this.locaisSelecionadosIds[j];
                }

                if (this.locais[i].local_id != local_selecionar_id) {
                  continue;
                }

                this.locais[i].selecionado = true;
                break;
              }
            }
          }
        }
        catch (erro) {
          toastr.error(erro.message);
        }
      },

      selecionarLocal(local_id) {
        if (this.multiSelecao == 'S') {
          for (let i = 0; i < this.locais.length; i++) {
            if (this.locais[i].local_id != local_id) {
              continue;
            }

            this.locais[i].selecionado = !this.locais[i].selecionado;
            break;
          }
        }
        else {
          for (let i = 0; i < this.locais.length; i++) {
            this.locais[i].selecionado = false;
            if (this.locais[i].local_id == local_id) {
              this.locais[i].selecionado = true;
            }
          }
        }

        this.locais = JSON.parse(JSON.stringify(this.locais));
      },

      getClasseLocalSelecionado(selecionado) {
        if (selecionado) {
          return 'w3-theme label-clicavel';  
        }
        else {
          return 'w3-white label-clicavel';
        }
      },
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  @media (min-width: 993px) {
    .modal-container {
      width: 700px;
    }
  }

  @media (max-width: 768px) {
    .modal-container {
      width: 400px;
    }
  }

  .modal-container {
    border-radius: 12px;
    margin: auto;
    height: auto;
    padding: 20px 20px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    animation: animatezoom 0.6s;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  button {
    background: #9c1d1c;
    color: white;
    padding: 10px;
    border: 0 !important
  }

  .processar-btn {
    margin-top: 10px;
    padding: 5px;
  }

  .selecionado {
    background: #9c1d1c;
    color: white;
  }

  .pesquisar-titulo {
    margin: auto;
    text-align: center;
    cursor: pointer;
    border: #636363 1px solid;
    padding: 10px;
    transition: 0.1s;
    background: #9c1d1c;
    color: white;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 22px;
  }

  .pesquisar-titulo:hover {
    background: white;
    color: black
  }

  .titulo {
    border-bottom: 1px solid #9c1d1c;
    margin-bottom: 20px;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c;
  }

  @media screen and (max-width: 767px) {
    h2 {
      font-size: 24px;
      margin-bottom:15px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ModalLocais.vue